'use strict';

angular.module('app.user', [
    'app.error',
    'gettext',
    'user',
    'invitations',
    'route',
    'ui.router',
]);
